import Button from "../..";
import { useCopies } from "shared/hooks/useCopies";
import { ButtonComponentType, ButtonProps, CustomButtonProps, IconOnlyButtonProps } from "../../types";
import Icon from "assets/icons";
import Variant from "shared/enums/Variant";
import ButtonType from "shared/enums/ButtonTypes";
import React from "react";
import { getDefaultTitle } from "../../utils";
import classNames from "classnames";

export function __CreateButton__(props: ButtonProps) {
  const copies = useCopies();

  return (
    <Button
      label={copies.get("create")}
      title={getDefaultTitle({ title: props.title, label: props.label, default: copies.get("create") })}
      icon={<Icon.AddCircle />}
      {...props}
    />
  );
}

export function __DeleteButton__(props: ButtonProps) {
  const copies = useCopies();
  return (
    <Button
      label={copies.get("delete")}
      title={getDefaultTitle({ title: props.title, label: props.label, default: copies.get("delete") })}
      icon={<Icon.Delete />}
      variant={Variant.ERROR}
      {...props}
    />
  );
}

export function __EditButton__(props: ButtonProps) {
  const copies = useCopies();
  return (
    <Button
      label={copies.get("edit")}
      title={getDefaultTitle({ title: props.title, label: props.label, default: copies.get("edit") })}
      icon={<Icon.EditIcon />}
      {...props}
    />
  );
}

export function __SaveButton__(props: ButtonProps) {
  const copies = useCopies();
  return (
    <Button
      label={copies.get("save")}
      title={getDefaultTitle({ title: props.title, label: props.label, default: copies.get("save") })}
      icon={<Icon.Save size={15} />}
      type={props.onClick ? ButtonType.BUTTON : ButtonType.SUBMIT}
      {...props}
    />
  );
}

export function __AddButton__(props: ButtonProps) {
  const copies = useCopies();
  return (
    <Button
      label={copies.get("add")}
      title={getDefaultTitle({ title: props.title, label: props.label, default: copies.get("add") })}
      icon={<Icon.AddCircle />}
      {...props}
    />
  );
}

export function __CustomButton__(props: CustomButtonProps) {
  return <Button {...props} label={props.children as any} />;
}

export function __SettingButton__(props: ButtonProps) {
  return <Button icon={<Icon.Settings />} {...props} className={classNames("ptButton_setting", props.className)} />;
}
export function __CircleIconButton__(props: IconOnlyButtonProps) {
  return <Button {...props} className={classNames("ptButton_circleIcon", props.className)} />;
}

export function __LinkButton__(props: ButtonComponentType) {
  return <Button variant={Variant.LINK} {...props} className={classNames("ptButton_linkButton", props.className)} />;
}

export function __CloseButton__(props: ButtonProps) {
  return <Button icon={<Icon.Close />} {...props} className={classNames("ptButton_close", props.className)} />;
}

export function __PreviewButton__(props: ButtonProps) {
  const copies = useCopies();
  return <Button icon={<Icon.PreviewPage />} label={copies.get("preview")} variant={Variant.LINK} {...props} />;
}

export function __NeutralButton__(props: ButtonComponentType) {
  return (
    <Button
      {...props}
      className={classNames(props.className, {
        ptButton_neutral: !props.variant || props.variant === Variant.PRIMARY
      })}
    />
  );
}
